const WHEEL_GRACE_MS = 600;
const NAV_GAP = 12;

let userTookOver = false;
let scrollStartedAt = 0;

document.addEventListener('wheel', () => {
  if (performance.now() - scrollStartedAt > WHEEL_GRACE_MS) userTookOver = true;
}, { passive: true });

['touchstart', 'keydown'].forEach((type) => {
  document.addEventListener(type, () => { userTookOver = true; }, { passive: true });
});

function navOffset() {
  const nav = document.querySelector('.navbar');
  if (nav && getComputedStyle(nav).position === 'fixed') {
    const bottom = nav.getBoundingClientRect().bottom;
    if (bottom > 0) return bottom + NAV_GAP;
  }
  const navHeightRaw = getComputedStyle(document.documentElement).getPropertyValue('--nav-main-height');
  return (parseInt(navHeightRaw, 10) || 60) + NAV_GAP;
}

function reviewsTarget() {
  const section = document.querySelector('product-reviews-new');
  if (!section) return null;
  return section.querySelector('.col--reviews') || section;
}

function targetTop(el) {
  const maxY = document.documentElement.scrollHeight - window.innerHeight;
  return Math.min(el.getBoundingClientRect().top + window.scrollY - navOffset(), maxY);
}

function onScrollSettled(done) {
  let last = window.scrollY;
  let still = 0;
  let frames = 0;

  const tick = () => {
    frames += 1;
    const y = window.scrollY;
    if (Math.abs(y - last) < 1) {
      still += 1;
    } else {
      still = 0;
      last = y;
    }
    if (still >= 10 || frames > 180) {
      done();
      return;
    }
    requestAnimationFrame(tick);
  };

  requestAnimationFrame(tick);
}

function scrollToReviews(remaining = 4) {
  const el = reviewsTarget();
  if (!el) return;

  window.scrollTo({ top: targetTop(el), behavior: 'smooth' });

  onScrollSettled(() => {
    if (userTookOver || remaining <= 0) return;
    const target = reviewsTarget();
    if (target && Math.abs(window.scrollY - targetTop(target)) > 2) scrollToReviews(remaining - 1);
  });
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  if (!event.target.closest('product-reviews-new .pagination-prev, product-reviews-new .pagination-next')) return;

  userTookOver = false;
  scrollStartedAt = performance.now();
  scrollToReviews();
}, true);
